import { createDefaultNutritionRows } from "./nutritionTable";

let idCounter = 0;

const nextId = () => `el_${Date.now()}_${idCounter++}`;

const BASE = {
  x: 5,
  y: 5,
  width: 30,
  height: 10,
  rotation: 0,
  opacity: 1,
  hidden: false,
  locked: false,
};

export function createElement(type, zIndex = 0) {
  const id = nextId();
  switch (type) {
    case "text":
      return {
        id,
        type,
        zIndex,
        ...BASE,
        width: 40,
        height: 8,
        content: "Double click to edit text",
        fontFamily: "Poppins",
        fontSize: 12,
        bold: false,
        italic: false,
        underline: false,
        color: "#000000",
        backgroundColor: "transparent",
        textAlign: "left",
        borderWidth: 0,
        borderColor: "#000000",
        padding: 2,
      };
    case "image":
      return {
        id,
        type,
        zIndex,
        ...BASE,
        width: 20,
        height: 20,
        src: "",
        objectFit: "contain",
      };
    case "logo":
      return {
        id,
        type: "image",
        zIndex,
        ...BASE,
        width: 15,
        height: 15,
        src: "{{brand_logo}}",
        objectFit: "contain",
      };
    case "vegIcon":
      return {
        id,
        type,
        zIndex,
        ...BASE,
        width: 8,
        height: 8,
        fieldKey: "veg_type",
        valueSource: "dynamic",
        manualValue: "VEG",
      };
    case "fssaiBadge":
      return {
        id,
        type,
        zIndex,
        ...BASE,
        width: 34,
        height: 14,
        fieldKey: "fssai",
        valueSource: "dynamic",
        manualValue: "",
      };
    case "rect":
      return {
        id,
        type,
        zIndex,
        ...BASE,
        backgroundColor: "transparent",
        borderColor: "#000000",
        borderWidth: 1,
        borderRadius: 0,
      };
    case "circle":
      return {
        id,
        type,
        zIndex,
        ...BASE,
        width: 15,
        height: 15,
        backgroundColor: "transparent",
        borderColor: "#000000",
        borderWidth: 1,
      };
    case "line":
      return {
        id,
        type,
        zIndex,
        ...BASE,
        height: 1,
        borderColor: "#000000",
        borderWidth: 1,
      };
    case "barcode":
      return {
        id,
        type,
        zIndex,
        ...BASE,
        width: 40,
        height: 16,
        barcodeType: "CODE128",
        barcodeValue: "{{barcode}}",
      };
    case "qr":
      return {
        id,
        type,
        zIndex,
        ...BASE,
        width: 18,
        height: 18,
        barcodeType: "QR",
        barcodeValue: "{{qr}}",
      };
    case "nutrition":
      return {
        id,
        type,
        zIndex,
        ...BASE,
        width: 45,
        height: 40,
        fontSize: 8,
        fontFamily: "Poppins",
        title: "Nutrition (per 100g)",
        valueHeader: "Value",
        nutritionRows: createDefaultNutritionRows(),
      };
    default:
      return { id, type, zIndex, ...BASE };
  }
}

export function createDynamicFieldElement(fieldKey, fieldLabel, zIndex = 0) {
  if (fieldKey === "veg_type") {
    const el = createElement("vegIcon", zIndex);
    el.fieldLabel = fieldLabel;
    return el;
  }

  if (fieldKey === "fssai") {
    const el = createElement("fssaiBadge", zIndex);
    el.fieldLabel = fieldLabel;
    return el;
  }

  const el = createElement("text", zIndex);
  el.content = `${fieldLabel}: {{${fieldKey}}}`;
  el.width = 50;
  return el;
}
